import { supabase } from '../utils/supabaseClient';

export const signInAnonymously = async () => {
  try {
    // Check if already signed in
    const { data: { session } } = await supabase.auth.getSession();

    if (session && session.user) {
      // console.log("Already signed in:", session.user);
      return session.user; // return current user
    }

    // If no session, sign in anonymously
    const { data, error } = await supabase.auth.signInAnonymously();
    if (error) throw error;

    console.log('Signed in anonymously:', data.user);
    return data.user;
  } catch (error) {
    // console.error('Error signing in anonymously:', error.message);
    // alert('Error logging in as a guest.');
  }
};
